import { SystemDocumentEntry } from 'types'

export function allDocumentsHaveRevisionCodes(
  documents: SystemDocumentEntry[]
): boolean {
  return documents.every(
    (doc) =>
      doc.entry.data.revision_code !== undefined &&
      doc.entry.data.revision_code !== null &&
      doc.entry.data.revision_code !== ''
  )
}

export function getLatestDocumentByRevision(
  documents: SystemDocumentEntry[]
): SystemDocumentEntry | undefined {
  if (documents.length === 0) return undefined
  const sortedByRevision = [...documents].sort((a, b) => {
    const revA = a.entry.data.revision_code ?? ''
    const revB = b.entry.data.revision_code ?? ''

    const isANumber = /^\d+$/.test(revA)
    const isBNumber = /^\d+$/.test(revB)

    // Numbers are newer than letters: if types differ, number wins
    if (isANumber !== isBNumber) return isANumber ? -1 : 1

    // Same type: numbers compare numerically, letters alphabetically (descending)
    return isANumber
      ? parseInt(revB) - parseInt(revA)
      : revB.localeCompare(revA)
  })
  return sortedByRevision[0]
}
